import React from 'react';
import { partnerService } from '../../services/PartnerService';
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {connect} from "react-redux";
import LoginMain from "./LoginMain";
import {Slide, Paper} from "@material-ui/core";
import LoginForgetPass from "./LoginForgetPass";
import CustomSnackbar from "../navigation/CustomSnackbar";
import {INotificacion} from "../../types";


interface IProps {
    notification: INotificacion | null
    location?: any
    history?: any
    contacta: boolean
    forget_pass: boolean
    user: string
    password: string
    submit: boolean
    closeNotification(): void
    setError(error: null | string): void
    setSubmit(submit: boolean): void
}

interface IState {
    startTransitionMain: boolean
    startTransitionSecondary: boolean
}

class LoginPage extends React.Component<IProps, IState> {

    state: IState = {
        startTransitionMain: true,
        startTransitionSecondary: false,
    };

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (!this.props.submit && nextProps.submit) {
            this.props.setSubmit(false)
            this.handleSubmit()
                .then(() => {})
                .catch(() => {})
        }
        return true
    }

    handleSubmit = async() => {
        const logged = await partnerService.login(this.props.user, this.props.password);
        if (logged) {
            const { from } = this.props.location.state || { from: { pathname: "/" } };
            this.props.history.push(from);
        } else {
            this.props.setError('error')
            setTimeout(() => this.props.setError(null), 2000)
        }
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '100vh',
                    width: '100vw',
                    overflow: 'hidden'
                }}
            >
                <CustomSnackbar
                    open={this.props.notification != null}
                    variant={(this.props.notification != null) ? this.props.notification.variant: "info"}
                    message={this.props.notification && this.props.notification.message}
                    autoHideDuration={5000}
                    onClose={this.props.closeNotification}
                />
                <Slide
                    direction="left"
                    in={!this.props.contacta && !this.props.forget_pass && this.state.startTransitionMain}
                    timeout={800}
                    mountOnEnter
                    unmountOnExit
                    onEntered={() => this.setState({startTransitionSecondary: false})}
                    onExited={() => this.setState({startTransitionSecondary: true})}
                >
                    <Paper>
                        <LoginMain/>
                    </Paper>
                </Slide>

                <Slide
                    direction="left"
                    in={this.props.forget_pass && this.state.startTransitionSecondary}
                    timeout={800}
                    mountOnEnter
                    unmountOnExit
                    onEntered={() => this.setState({startTransitionMain: false})}
                    onExited={() => this.setState({startTransitionMain: true})}
                >
                    <Paper>
                        <LoginForgetPass/>
                    </Paper>
                </Slide>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    notification: state.navegacion.notification,
    contacta: state.login.contacta,
    forget_pass: state.login.forget_pass,
    user: state.login.user,
    password: state.login.password,
    submit: state.login.submit
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    closeNotification: () => dispatch({type: "notify", notification: null}),
    setError: (error: null | string) => dispatch({type: "set-login-error", error}),
    setSubmit: (submit: boolean) => dispatch({type: "set-login-submit", submit})
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
